import { getNewRelicTraceHeaders } from '@/components/app/NewRelic/NewRelicAgent'
import logger from './logger'

const getDownloadFiles = async (url: string): Promise<Response | undefined> => {
	try {
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Accept: 'application/octet-stream',
				'Content-Type': 'application/octet-stream',
				...getNewRelicTraceHeaders(),
			},
		})

		if (!response.ok) {
			console.error('File fetch failed:', response.status)
			throw new Error(`Failed to fetch file: ${response.status}`)
		}

		return response
	} catch (error) {
		console.error('Error retrieving download:', error)
		logger('Error retrieving download', error, {
			errorType: 'Download API',
			fetchUrl: url,
		})
	}
}
export default getDownloadFiles
